import React from 'react';
import ab2 from '../assets/ab2.png';
import ab1 from '../assets/ab1.png';
import ab3 from '../assets/ab3.png';
import ModernResources from './modern/ModernResources';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
const RESOURCES = [
  {
    img: ab2,
    title: "First Nations Public Service Secretariat",
    text: "Supports B.C. First Nations communities and organizations across the core public service sectors as they build strong governments and administrations.",
    href: 'https://fnps.ca/',
  },
  {
    img: ab1,
    title: "Northern Aboriginal Economic Opportunities",
    text: "CanNor’s program (NAEOP) supports northern Inuit, First Nations and Métis communities and businesses to pursue employment and economic opportunities.",
    href: 'https://www.cannor.gc.ca/eng/1385486556734/1385486648146',
  },
  {
    img: ab3,
    title: "Government of Canada jobs for Indigenous people",
    text: "The federal public service is hiring Indigenous people, including students and graduates, to build a more inclusive and representative public service.",
    href: 'https://www.canada.ca/en/public-service-commission/jobs/services/gc-jobs/jobs-indigenous-people.html',
  },
];

export default function Resources() {
  return <ModernResources items={RESOURCES} />;
}
